<template>
  <div class="weiVCon videoD">
    <div class="videoDetailBox">
      <div
        class="weiVImgBox"
        @click="toStudy"
      >
        <div class="mask"></div>
        <img
          :src="videoImg"
          alt=""
          class="weiVImg"
          :onerror="defaultImg"
        />
        <img
          src="../assets/imgs/playIcon.png"
          alt=""
          class="toPlay"
        />
        <span>{{ videoTime }}</span>
      </div>
      <div class="videoInfos">
        <div class="clearfix">
          <div class="fl vdTit">{{videoTit}}</div>
          <!-- <div class="fr">收藏<img
              src="../assets/imgs/shoucang.png"
              alt=""
              class="isSC"
            ></div> -->
        </div>
        <p>主讲人:<span>{{videoPeople}}</span></p>
        <p>主讲单位:<span>{{videoCompany}}</span></p>
        <p>课程时长:<span>{{ videoTime  }}</span></p>
        <p class="videoInfo">简介:<span>{{videoTxt}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'videoD',
  data () {
    return {
      defaultImg: 'this.src="' + require('../assets/imgs/banner.png') + '"', // 默认图地址
      vType: 0, // vType:0--不记时视频 1--要计时视频
      vObj: null,
      player: null,
      videoImg: '',
      videoTit: '',
      videoPeople: '李四',
      videoCompany: '西安市十一中高中部',
      videoTime: '02:23',
      videoTxt:
        '《新疆维吾尔自治区去极端化条例》全文共分七章。包括总则、极端化的主要表现，共52条。 2017年3月29日新疆维吾尔自治',
      StudyMonth: '',
      folderId: ''
    }
  },
  created () {
    this.StudyMonth = this.$route.query.year
    this.folderId = this.$route.query.folderId

    this.vType = this.$route.query.vType
    this.vObj = JSON.parse(this.$route.query.vObj)
    this.videoTit = this.vObj.title
    this.videoPeople = this.vObj.speaker //this.checkvideoPeople(this.vObj.speaker)
    this.videoCompany = this.vObj.lectureunit //this.checkvideoCompany(this.vObj.lectureunit)
    if (this.$route.query.vType === 0) {
      this.videoImg = this.vObj.imagePath
    } else {
      this.videoImg = window.baseapi.baseUrl + this.vObj.image_path
    }
    this.videoTime = this.vObj.dataduration
    this.videoTxt = this.vObj.description
  },
  mounted () {},
  methods: {
    toStudy: function () {
      console.log(this.vType + '@@!@!@!@')
      if (this.vType === 0) {
        this.$router.replace({
          path: '/vPlay',
          query: { videoObj: JSON.stringify(this.vObj) }
        })
      } else if (this.vType === 1) {
        this.$router.replace({
          path: '/v',
          query: {
            videoObj: JSON.stringify(this.vObj),
            year: this.StudyMonth,
            folderId: this.folderId
          }
        })
      }
    },
    checkvideoPeople (value) {
      if (value === '' || value === null || value === undefined) {
        return '交通安全技术专家'
      }
    },
    checkvideoCompany (value) {
      if (value === '' || value === null || value === undefined) {
        return '交通安全主讲单位'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/videoDetail.vue